import React from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Tooltip from "@material-ui/core/Tooltip";
import styled from "styled-components/macro";

import { useIsMobile } from "hooks";

import { SidebarButton } from "./SidebarButton";

export const SideBarLabel = styled(ListItemText)`
  padding-left: 30px;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 32px;
  white-space: nowrap;
`;

interface SidebarListItemProps {
  onClick: () => void;
  icon: IconDefinition;
  label: string;
  dataTour?: string;
  background?: string;
  tooltip?: string;
}

export const SidebarListItem = ({
  onClick,
  icon,
  label,
  dataTour = label,
  background,
  tooltip,
}: SidebarListItemProps) => {
  const isMobile = useIsMobile();
  const listItem = (
    <ListItem button onClick={onClick} data-tour={dataTour}>
      <SidebarButton icon={icon} background={background} />
      <SideBarLabel primary={label} />
    </ListItem>
  );
  if (isMobile) {
    return listItem;
  }
  return (
    <Tooltip title={tooltip ?? label} placement="right">
      {listItem}
    </Tooltip>
  );
};
